import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { http } from "@/lib/api";

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    http.get(`/pages/by-slug/${slug}`).then((r) => setPage(r.data)).catch(() => setErr("Page not found"));
  }, [slug]);
  if (err) return <div className="bls-container py-24 text-center text-black/50">{err}</div>;
  if (!page) return <div className="bls-container py-24"><div className="bls-shimmer h-96 rounded-2xl" /></div>;
  return (
    <div className="bls-container py-16 max-w-3xl">
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter">{page.title}</h1>
      <div className="mt-8 prose prose-lg max-w-none text-black/75 leading-relaxed" dangerouslySetInnerHTML={{ __html: page.content }} />
    </div>
  );
}
